import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e1f53c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundAnimation = _resolveComponent("BackgroundAnimation")!
  const _component_loading = _resolveComponent("loading")!
  const _component_alert = _resolveComponent("alert")!
  const _component_n_message_provider = _resolveComponent("n-message-provider")!
  const _component_n_notification_provider = _resolveComponent("n-notification-provider")!
  const _component_Header = _resolveComponent("Header")!
  const _component_n_layout_header = _resolveComponent("n-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_layout_content = _resolveComponent("n-layout-content")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_n_layout_footer = _resolveComponent("n-layout-footer")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_n_loading_bar_provider = _resolveComponent("n-loading-bar-provider")!
  const _component_n_config_provider = _resolveComponent("n-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BackgroundAnimation),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_n_config_provider, {
        theme: _ctx.darkT,
        "theme-overrides": _ctx.themeOverride
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_loading_bar_provider, null, {
            default: _withCtx(() => [
              _createVNode(_component_loading),
              _createVNode(_component_n_notification_provider, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_message_provider, { placement: "bottom" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_alert)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_n_layout, {
                "native-scrollbar": false,
                position: "absolute"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_layout_header, {
                    bordered: "",
                    class: "header-layout"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Header)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_layout_content, {
                    embedded: "",
                    id: "content",
                    "native-scrollbar": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view, {
                        key: _ctx.$route.path
                      }, {
                        default: _withCtx(({ Component }) => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { class: "content" }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_layout_footer, { bordered: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Footer)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["theme", "theme-overrides"])
    ])
  ], 64))
}